<template>
    <input type="text" :class="aspect.formFieldClass" v-model="fieldValue" :placeholder="placeholder" @input="emitChange()" />
</template>

<script>
    export default {
        name: 'form-element-piva',
        props: {
            value:{ type:String },
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }},
            placeholder: null
        },
        data(){
            return {
                fieldValue: this.value,
            }
        },
        methods: {
            emitChange(){
                this.$emit('input', this.fieldValue);
            },
            async evaluateValidationCondition(condition){
                if(condition.type == "vat"){
                    var pi = this.value+"";
                    if( pi == '' )  return '';
                    if( ! /^([a-zA-Z]{2})?[0-9]{11}$/.test(pi) )
                        return this.translations.vatWarning;
                    if( /^[0-9]{11}$/.test(pi) ) {
                        var s = 0;
                        for( i = 0; i <= 9; i += 2 )
                            s += pi.charCodeAt(i) - '0'.charCodeAt(0);
                        for(var i = 1; i <= 9; i += 2 ){
                            var c = 2*( pi.charCodeAt(i) - '0'.charCodeAt(0) );
                            if( c > 9 )  c = c - 9;
                            s += c;
                        }
                        var atteso = ( 10 - s%10 )%10;
                        return ( atteso != pi.charCodeAt(10) - '0'.charCodeAt(0) )?this.translations.vatWarning:null;
                    }else {
                        return null;
                    }
                }
            }
        }
    }
</script>
